export enum SendRequestEnum {
  Accepted = 'accepted',
  Pending = 'pending',
  NotExist = 'not exist',
}
